import { render, staticRenderFns } from "./Accident.vue?vue&type=template&id=28b48d50&"
import script from "./Accident.vue?vue&type=script&lang=ts&"
export * from "./Accident.vue?vue&type=script&lang=ts&"
import style0 from "./Accident.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports